import ImageUploadPlaceholder from '@cp/src/assets/icons/ImageUploadPlaceholder';
import Button from '@navi/web-ui/lib/primitives/Button/Button';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import styles from './index.module.scss';
import UploadComponent from '@cp/src/components/UploadComponent/UploadComponent';
import UploadSuccessComponent from '@cp/src/components/UploadComponent/UploadSuccessComponent';

interface ProofOfNumberSourceContainerProps {
  proofOfSourceFile: File | null;
  setProofOfSourceFile: (file: File | null) => void;
  setProofOfSourceError: (error: string) => void;
  proofOfSourceError: string;
}

const ProofOfNumberSourceContainer = ({
  proofOfSourceFile,
  setProofOfSourceFile,
  setProofOfSourceError,
  proofOfSourceError
}: ProofOfNumberSourceContainerProps) => {
  const ProofOfNumberSource = (handleUploadClick: (e: React.ChangeEvent<any>) => void) => {
    return (
      <div className="upload-container-content flex flex-col items-center justify-center pt-4 w-full">
        <ImageUploadPlaceholder />
        <Button variant="text" onClick={handleUploadClick} className="text-nowrap !w-[100%]">
          Click to upload or drag and drop here
        </Button>
      </div>
    );
  };

  return (
    <div className="mt-4">
      <Typography className={styles.enterPhoneNumber} variant={'p4'}>
        {proofOfSourceFile ? 'Screenshot of source of number' : 'Upload proof of source'}{' '}
        <span className="text-red-500">*</span>
      </Typography>
      <div className="mt-2">
        {proofOfSourceFile ? (
          <UploadSuccessComponent
            containerClassName="!m-0 w-full"
            name={proofOfSourceFile?.name || ''}
            isInProgress={false}
            onCancel={() => {
              setProofOfSourceFile(null);
              setProofOfSourceError('');
            }}
          />
        ) : (
          <UploadComponent
            setFile={setProofOfSourceFile}
            file={proofOfSourceFile}
            uploadContentContainer={ProofOfNumberSource}
            isValidationInfoVisible={true}
            supportedFile={'.jpeg,.png'}
            MAX_FILE_SIZE_IN_MB={5}
            containerClassName="!m-0 w-full !p-0"
            textClassnameContainer=""
            setHasError={({ message }) => setProofOfSourceError(String(message))}
          />
        )}
      </div>
    </div>
  );
};

export default ProofOfNumberSourceContainer;
